<template>
	<div>
		<el-select v-model="newWorkshop" placeholder="车间选择" :clearable="true">
			<el-option v-for="item in workshops" :key="item._id.$oid" :label="item.name" :value="item._id.$oid"> </el-option>
		</el-select>
	</div>
</template>

<script>
	import { workshopRequest } from '@/network/requests/workshop'
	export default {
		model: {
			prop: 'workshop',
			event: 'change',
		},
		props: {
			workshop: {
				required: true,
			},
		},
		data() {
			return {
				newWorkshop: this.workshop,
				workshops: [],
			}
		},
		watch: {
			newWorkshop(newVal) {
				this.$emit('change', newVal)
			},
		},
		methods: {},
		async created() {
			console.log('newWorkshop', this.newWorkshop)
			this.workshops = await workshopRequest.queryAll()
		},
	}
</script>

<style></style>
